(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[712],{

/***/ 3976:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pricing-plan",
      function () {
        return __webpack_require__(6663);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ck": function() { return /* binding */ CardFaq; },
/* harmony export */   "cO": function() { return /* binding */ CardAuctionDetail; },
/* harmony export */   "dg": function() { return /* binding */ CardFacilityDetail; },
/* harmony export */   "fe": function() { return /* binding */ CardAuction; },
/* harmony export */   "ue": function() { return /* binding */ InfoWindowFacility; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1351);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8368);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4357);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _icon_SvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8377);
/* harmony import */ var _image_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4532);






var CardAuction = function(param) {
    var param = param !== null ? param : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "flex flex-row items-center space-x-2 w-[15.375rem] min-w-fit",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "min-w-[3.375rem]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    src: "/images/img-example.png",
                    alt: "",
                    className: "w-[3.375rem] object-cover rounded-xl"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col space-y-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-regular-normal font-medium text-neutral-900 break-all line-clamp-1",
                        children: "Central xxxxx xxxx xxxx"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-row items-center space-x-1.5",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-neutral-900",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_2__/* .LocationBoldIcon */ .Oi, {
                                    size: "16"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "break-all line-clamp-1 text-tiny-none text-neutral-800",
                                children: "Fresno, xxxxx xxxxx xxxx"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var CardAuctionDetail = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: "/facility/detail/".concat(data.slug),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
            className: "flex flex-row items-center space-x-2 w-[15.375rem] min-w-fit",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "min-w-[4.25rem]",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        src: data.image.md,
                        alt: data.name,
                        className: "w-[4.25rem] object-cover rounded-xl"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col space-y-1.5",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-regular-normal font-medium text-neutral-900 break-all line-clamp-1",
                            children: data.name
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "font-bold text-primary-500 text-small-tight",
                            children: [
                                "#",
                                data.id,
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "font-normal text-neutral-600 capitalize",
                                    children: [
                                        data.type ? data.type === "in_person" ? "in person" : data.type : "Caravan",
                                        " ",
                                        "Auction"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-row items-center space-x-1.5",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "text-neutral-900",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_2__/* .LocationBoldIcon */ .Oi, {
                                        size: "16"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "break-all line-clamp-1 text-tiny-none text-neutral-800",
                                    children: data.address
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var InfoWindowFacility = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "bg-white rounded-xl p-3 w-[11.75rem] flex flex-col focus:!outline-none focus-visible:!outline-none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                src: data.image.lg,
                alt: data.name,
                className: "w-full h-[5.25rem] rounded-lg object-cover"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "font-medium text-small-normal text-neutral-900 truncate whitespace-normal line-clamp-2 break-all mt-2",
                children: data.name
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-1 font-bold text-primary-500 text-tiny-tight",
                children: [
                    "#",
                    data.id
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-1.5 text-neutral-500 text-tiny-tight",
                children: [
                    data.type ? data.type === "in_person" ? "in person" : data.type : "Caravan",
                    " ",
                    "Auction"
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-tiny-normal text-neutral-600 line-clamp-2 break-all mt-1",
                children: data.address
            })
        ]
    });
};
var CardFacilityDetail = function(param) {
    var data = param.data, isBlur = param.isBlur;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "relative flex flex-row items-center justify-between w-full md:w-[33.438rem] min-w-fit bg-white p-3.5 rounded-xl",
        children: [
            isBlur && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute left-0 bg-white w-full h-full opacity-50"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-row items-center space-x-3.5",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-[5.25rem]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            src: data.image.lg,
                            alt: data.unit_number,
                            className: "w-[5.25rem] object-cover rounded-xl"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col space-y-1.5",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "text-regular-none md:text-title3 font-bold text-neutral-900 break-all line-clamp-1",
                                children: [
                                    "#",
                                    data.unit_number
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "font-medium text-neutral-900 text-small-normal",
                                children: "Start this week"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "break-all line-clamp-1 text-tiny-normal md:text-regular-normal text-neutral-600",
                                children: "1,200 watching this auction"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "border border-neutral-200 rounded-full p-2 text-primary-500 md:hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_2__/* .SaveAddIcon */ .PF, {
                    size: "16"
                })
            })
        ]
    });
};
var CardFaq = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "mx-auto w-full rounded-[0.875rem] bg-white px-3 py-3.5",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Disclosure */ .p, {
                children: function(param) {
                    var open = param.open;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Disclosure.Button */ .p.Button, {
                                className: "flex w-full justify-between space-x-1 text-left text-[1.375rem] leading-6 font-bold text-primary-900 focus:outline-none",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "break-words line-clamp-2",
                                        children: data.attributes.title
                                    }),
                                    open ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_2__/* .CloseCircleIcon */ .uC, {
                                        className: "text-neutral-500 min-w-[1.5rem]"
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_2__/* .AddBoldCircleIcon */ .S4, {
                                        className: "text-primary-500 min-w-[1.5rem]"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Transition */ .u, {
                                enter: "transition ease duration-500 transform",
                                enterFrom: "opacity-0 -translate-y-12",
                                enterTo: "opacity-100 translate-y-0",
                                leave: "transition ease duration-300 transform",
                                leaveFrom: "opacity-100 translate-y-0",
                                leaveTo: "opacity-0 -translate-y-12",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Disclosure.Panel */ .p.Panel, {
                                    className: "mt-4.5 text-regular-normal text-neutral-600",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "break-words line-clamp-3",
                                            children: data.attributes.short_description
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: "/faq/".concat(data.attributes.slug),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                className: "font-bold text-primary-500",
                                                children: "Read More..."
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    });
                }
            })
        })
    });
};


/***/ }),

/***/ 3140:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D9": function() { return /* binding */ LoadingFaq; },
/* harmony export */   "Qu": function() { return /* binding */ LoadingMap; },
/* harmony export */   "TX": function() { return /* binding */ NotFound; },
/* harmony export */   "YO": function() { return /* binding */ LoadingFacility; },
/* harmony export */   "tf": function() { return /* binding */ LoadingPricingPlan; },
/* harmony export */   "v1": function() { return /* binding */ LoadingBlog; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_content_loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4561);
/* harmony import */ var _image_Image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4532);



var LoadingPricingPlan = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "mt-8 flex flex-col px-6 py-4.5 rounded-3xl bg-neutral-100 border border-neutral-200 w-full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    width: "100%",
                    height: "96px",
                    foregroundColor: "#EDF2F7",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        x: "0",
                        y: "0",
                        rx: "12",
                        ry: "12",
                        width: "100%",
                        height: 96
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-[2.125rem]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    width: "100%",
                    height: "52px",
                    foregroundColor: "#EDF2F7",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        x: "0",
                        y: "0",
                        rx: "12",
                        ry: "12",
                        width: "100%",
                        height: 52
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-[2.125rem]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    width: "100%",
                    height: "48px",
                    foregroundColor: "#EDF2F7",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        x: "0",
                        y: "0",
                        rx: "40",
                        ry: "40",
                        width: "100%",
                        height: 48
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-[2.125rem]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    width: "100%",
                    height: "30px",
                    foregroundColor: "#EDF2F7",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        x: "0",
                        y: "0",
                        rx: "8",
                        ry: "8",
                        width: "100%",
                        height: 30
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-3",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    width: "100%",
                    height: "30px",
                    foregroundColor: "#EDF2F7",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        x: "0",
                        y: "0",
                        rx: "8",
                        ry: "8",
                        width: "70%",
                        height: 30
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-3",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    width: "100%",
                    height: "30px",
                    foregroundColor: "#EDF2F7",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        x: "0",
                        y: "0",
                        rx: "8",
                        ry: "8",
                        width: "50%",
                        height: 30
                    })
                })
            })
        ]
    });
};
var LoadingMap = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full h-full rounded-[0.875rem] bg-neutral-200 flex flex-col justify-between p-4.5",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    width: "100%",
                    height: "72px",
                    foregroundColor: "#E2E8F0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        x: "0",
                        y: "0",
                        rx: "40",
                        ry: "40",
                        width: "100%",
                        height: 72
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    width: "100%",
                    height: "64px",
                    foregroundColor: "#E2E8F0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        x: "0",
                        y: "0",
                        rx: "12",
                        ry: "12",
                        width: "100%",
                        height: 64
                    })
                })
            })
        ]
    });
};
var LoadingFacility = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("td", {
                scope: "row",
                className: "p-3 flex flex-row items-center space-x-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-[2.5rem]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                            width: "100%",
                            height: "40px",
                            foregroundColor: "#E2E8F0",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                x: "0",
                                y: "0",
                                rx: "12",
                                ry: "12",
                                width: "100%",
                                height: 40
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col space-y-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                                    width: "100%",
                                    height: "16px",
                                    foregroundColor: "#E2E8F0",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                        x: "0",
                                        y: "0",
                                        rx: "6",
                                        ry: "6",
                                        width: "100%",
                                        height: 16
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                                    width: "100%",
                                    height: "16px",
                                    foregroundColor: "#E2E8F0",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                        x: "0",
                                        y: "0",
                                        rx: "6",
                                        ry: "6",
                                        width: "50%",
                                        height: 14
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("td", {
                className: "p-3 ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                            width: "100%",
                            height: "16px",
                            foregroundColor: "#E2E8F0",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                x: "0",
                                y: "0",
                                rx: "6",
                                ry: "6",
                                width: "100%",
                                height: 16
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                            width: "100%",
                            height: "16px",
                            foregroundColor: "#E2E8F0",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                x: "0",
                                y: "0",
                                rx: "6",
                                ry: "6",
                                width: "50%",
                                height: 14
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("td", {
                className: "p-3 ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                            width: "100%",
                            height: "16px",
                            foregroundColor: "#E2E8F0",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                x: "0",
                                y: "0",
                                rx: "6",
                                ry: "6",
                                width: "100%",
                                height: 16
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                            width: "100%",
                            height: "16px",
                            foregroundColor: "#E2E8F0",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                x: "0",
                                y: "0",
                                rx: "6",
                                ry: "6",
                                width: "50%",
                                height: 14
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("td", {
                className: "p-3 ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                            width: "100%",
                            height: "16px",
                            foregroundColor: "#E2E8F0",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                x: "0",
                                y: "0",
                                rx: "6",
                                ry: "6",
                                width: "100%",
                                height: 16
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                            width: "100%",
                            height: "16px",
                            foregroundColor: "#E2E8F0",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                x: "0",
                                y: "0",
                                rx: "6",
                                ry: "6",
                                width: "50%",
                                height: 14
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var LoadingFaq = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full h-[4.5rem]",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
            width: "100%",
            height: "72px",
            foregroundColor: "#EDF2F7",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0",
                y: "0",
                rx: "14",
                ry: "14",
                width: "100%",
                height: 72
            })
        })
    });
};
var NotFound = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col justify-center items-center h-full text-center w-full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image_Image__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                src: "/images/illustration/box.svg",
                alt: "Not Found",
                className: "w-[7.75rem] h-[7.75rem] mt-9"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-7",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                        className: "text-neutral-900 text-title3",
                        children: "No Records"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "text-neutral-600 text-regular-tight mt-4.5",
                        children: [
                            "there’s no any ",
                            props.message || "records",
                            " found"
                        ]
                    })
                ]
            })
        ]
    });
};
var LoadingBlog = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-col",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                        width: "100%",
                        height: "250px",
                        foregroundColor: "#EDF2F7",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            x: "0",
                            y: "0",
                            rx: "14",
                            ry: "14",
                            width: "100%",
                            height: "250"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mt-3.5",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                        width: "100%",
                        height: "20px",
                        foregroundColor: "#EDF2F7",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            x: "0",
                            y: "0",
                            rx: "6",
                            ry: "6",
                            width: "110",
                            height: "20"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mt-3.5",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                        width: "100%",
                        height: "34px",
                        foregroundColor: "#EDF2F7",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            x: "0",
                            y: "0",
                            rx: "8",
                            ry: "8",
                            width: "222",
                            height: "34"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mt-2",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                        width: "100%",
                        height: "112px",
                        foregroundColor: "#EDF2F7",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            x: "0",
                            y: "0",
                            rx: "8",
                            ry: "8",
                            width: "100%",
                            height: "112"
                        })
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 8919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lp": function() { return /* binding */ client; }
/* harmony export */ });
/* unused harmony exports createNewClient, isAxiosError */
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7041);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(cookies_next__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var https__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8428);
/* harmony import */ var https__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(https__WEBPACK_IMPORTED_MODULE_2__);




var httpsAgent = new (https__WEBPACK_IMPORTED_MODULE_2___default().Agent)({
    rejectUnauthorized: false
});
var createNewClient = function() {
    return axios__WEBPACK_IMPORTED_MODULE_0___default().create({
        baseURL: "https://apis.storageunitauctionlist.com",
        headers: {
            "x-api-key": "ethHL7HmLCaw8GxWpuZkoFCOCgjR9ptmcDXvXjKN7td8x9bv9UhRyTp59wrN",
            Accept: "application/json",
            "Cache-Control": "max-age=600"
        },
        httpsAgent: httpsAgent
    });
};
var client = createNewClient();
client.interceptors.request.use(function(config) {
    var anonId = (0,cookies_next__WEBPACK_IMPORTED_MODULE_1__.getCookie)("anonId") || "";
    if (anonId) {
        config.headers["X-Segment-Anon-Id"] = anonId;
    }
    return config;
}, function(err) {
    return Promise.reject(err);
});
client.interceptors.response.use(function(response) {
    return response;
}, function(error) {
    if (error.response.status === 401) {
        (0,cookies_next__WEBPACK_IMPORTED_MODULE_1__.deleteCookie)("__AUTH_TOKEN");
        window.location.href = "/";
    }
    return Promise.reject(error);
});
var useAxios = function(accessToken) {
    client.interceptors.request.use(function(config) {
        var newConfig = _object_spread({}, config);
        if (accessToken) {
            newConfig.headers.Authorization = "Bearer ".concat(accessToken);
        }
        return newConfig;
    });
    return client;
};
var isAxiosError = (axios__WEBPACK_IMPORTED_MODULE_0___default().isAxiosError);
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useAxios)));


/***/ }),

/***/ 6663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pricing_plan; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var src_object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(1351);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 5 modules
var _to_consumable_array = __webpack_require__(797);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-animation-on-scroll/dist/esm/index.js + 2 modules
var esm = __webpack_require__(6200);
// EXTERNAL MODULE: ./app/component/commons/button/Button.tsx
var Button = __webpack_require__(1201);
// EXTERNAL MODULE: ./app/component/commons/card/Card.tsx
var Card = __webpack_require__(7268);
// EXTERNAL MODULE: ./app/component/commons/icon/SvgIcon.tsx
var SvgIcon = __webpack_require__(8377);
// EXTERNAL MODULE: ./app/component/commons/image/Image.tsx
var Image = __webpack_require__(4532);
// EXTERNAL MODULE: ./app/component/commons/loading/Skeleton.tsx
var Skeleton = __webpack_require__(3140);
// EXTERNAL MODULE: ./app/component/commons/meta/Meta.tsx
var Meta = __webpack_require__(1817);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/@react-google-maps/api/dist/esm.js
var dist_esm = __webpack_require__(7054);
// EXTERNAL MODULE: ./node_modules/luxon/src/luxon.js + 23 modules
var luxon = __webpack_require__(120);
;// CONCATENATED MODULE: ./app/helpers/types/getTypes.ts
var CalculateDefaultValue = {
    city: "",
    zipcode: "",
    found: {
        facilities: [],
        upcoming_auction: 0,
        avg_auction_monthly: 0
    },
    pricing: {
        monthly: 0,
        yearly: 0,
        yearly_save_value: 0,
        yearly_save_percentage: 0
    }
};

// EXTERNAL MODULE: ./app/utils/axios.ts
var axios = __webpack_require__(8919);
// EXTERNAL MODULE: ./app/component/plugins/map/AutoCompleteMap.tsx + 1 modules
var AutoCompleteMap = __webpack_require__(4230);
// EXTERNAL MODULE: ./app/component/plugins/map/helper.ts
var helper = __webpack_require__(2712);
// EXTERNAL MODULE: ./node_modules/rc-slider/es/index.js + 42 modules
var es = __webpack_require__(6337);
// EXTERNAL MODULE: ./node_modules/rc-slider/assets/index.css
var assets = __webpack_require__(7042);
;// CONCATENATED MODULE: ./app/component/plugins/map/RadiusWaypoints.tsx




var RadiusWaypoints = function(param) {
    var radius = param.radius, onChange = param.onChange, onAfterChange = param.onAfterChange, marks = param.marks, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "group relative ".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-fit absolute inset-x-0 bottom-full mx-auto items-center justify-center opacity-0 mb-4 group-hover:opacity-100 md:flex hover-anime hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "bg-white rounded-xl p-3 w-[9.063rem] flex flex-col justify-center items-center space-y-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-tiny-none text-neutral-600 text-center",
                            children: "Move slider to resize your radius"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "font-bold text-small-tight text-neutral-900",
                            children: [
                                radius.miles,
                                "miles"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-white p-2 px-5 w-full shadow-lv3 rounded-xl relative h-[3.75rem]",
                children: radius.miles > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.Z, {
                    min: 1,
                    max: Object.keys(marks).length,
                    defaultValue: Number((0,helper/* getKeyByValue */.V9)(marks, radius.miles.toString())),
                    value: Number((0,helper/* getKeyByValue */.V9)(marks, radius.miles.toString())),
                    onChange: function(e) {
                        var cek = marks[e.toString()];
                        if (cek) {
                            onChange === null || onChange === void 0 ? void 0 : onChange(Number(cek));
                        }
                    },
                    onAfterChange: function(e) {
                        var cek = marks[e.toString()];
                        if (cek) {
                            onAfterChange === null || onAfterChange === void 0 ? void 0 : onAfterChange(Number(cek));
                        }
                    },
                    marks: marks,
                    step: null,
                    railStyle: {
                        backgroundColor: "#e2e8f0"
                    },
                    trackStyle: {
                        backgroundColor: "#3366FF"
                    },
                    handleStyle: {
                        width: "1.25rem",
                        height: "1.25rem",
                        border: "solid 1px #3366FF",
                        opacity: "1",
                        backgroundColor: "#3366FF",
                        marginTop: "-8px"
                    },
                    dotStyle: {
                        border: "solid 1px #CBD5E0",
                        backgroundColor: "#CBD5E0",
                        width: "1.25rem",
                        height: "1.25rem",
                        bottom: "-8px"
                    },
                    activeDotStyle: {
                        border: "solid 1px #3366FF",
                        backgroundColor: "#3366FF"
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var map_RadiusWaypoints = (RadiusWaypoints);

;// CONCATENATED MODULE: ./app/component/plugins/map/Map.tsx
















var defaultValueCalculate = {
    lat: helper/* MAP_DEFAULT.lat.toString */.he.lat.toString(),
    lng: helper/* MAP_DEFAULT.lng.toString */.he.lng.toString(),
    radius: null,
    map_zoom: 11,
    times: ""
};
var Map = function(param) {
    var mode = param.mode, onChange = param.onChange, setTotal = param.setTotal, onLoading = param.onLoading, getCity = param.getCity;
    var router = (0,next_router.useRouter)();
    var ref = (0,dist_esm/* useJsApiLoader */.Ji)(helper/* LOADER */.gI), isLoaded = ref.isLoaded, loadError = ref.loadError;
    var ref1 = (0,react.useState)(true), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(true), loadingCluster = ref2[0], setLoadingCluster = ref2[1];
    var ref3 = (0,react.useState)(helper/* MAP_DEFAULT */.he), defaultCenter = ref3[0], setDefaultCenter = ref3[1];
    var ref4 = (0,react.useState)(helper/* MAP_DEFAULT */.he), center = ref4[0], setCenter = ref4[1];
    var ref5 = (0,react.useState)({
        default: 11,
        min: 4
    }), zoom = ref5[0], setZoom = ref5[1];
    var ref6 = (0,react.useState)(), wayvalue = ref6[0], setWayvalue = ref6[1];
    var ref7 = (0,react.useState)(true), visible = ref7[0], setVisible = ref7[1];
    var ref8 = (0,react.useState)({
        miles: 0,
        meter: 0,
        min: 0,
        max: 500,
        mobile: 0,
        waypoints: []
    }), radius = ref8[0], setRadius = ref8[1];
    var ref9 = (0,react.useState)(""), city = ref9[0], setCity = ref9[1];
    var ref10 = (0,react.useState)(""), searchShow = ref10[0], setSearchShow = ref10[1];
    var ref11 = (0,react.useState)(false), disabled = ref11[0], setDisabled = ref11[1];
    var ref12 = (0,react.useState)({
        status: "",
        data: CalculateDefaultValue,
        times: ""
    }), items = ref12[0], setItems = ref12[1];
    var ref13 = (0,react.useState)({
        lat: "",
        lng: "",
        radius: "",
        times: luxon/* DateTime.now */.ou.now().toISO(),
        total: 0,
        map_zoom: 11
    }), params = ref13[0], setParams = ref13[1];
    var ref14 = (0,react.useState)({
        lat: "",
        lng: ""
    }), lastParams = ref14[0], setLastParams = ref14[1];
    var ref15 = (0,react.useState)(""), type = ref15[0], setType = ref15[1];
    var ref16 = (0,react.useState)(false), delay = ref16[0], setDelay = ref16[1];
    var ref17 = (0,react.useState)(null), placeID = ref17[0], setPlaceID = ref17[1];
    var ref18 = (0,react.useState)(defaultValueCalculate), paramsQuery = ref18[0], setParamsQuery = ref18[1];
    var ref19 = (0,react.useState)(""), typeFac = ref19[0], setTypeFac = ref19[1];
    var ref20 = (0,react.useState)([]), facility = ref20[0], setFacility = ref20[1];
    var ref21 = (0,react.useState)(0), totalFac = ref21[0], setTotalFac = ref21[1];
    var clustererRef = (0,react.useRef)();
    var ref22 = (0,react.useState)(null), map = ref22[0], setMap = ref22[1];
    var onLoad = (0,react.useCallback)(function callback(map) {
        setMap(map);
    }, [
        center
    ]);
    var onUnmount = (0,react.useCallback)(function callback(map) {
        setMap(null);
    }, []);
    // ONBOUND CIRCLE
    var onBoundCircle = function(map) {
        var event = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "idle", local = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
        var zoomLevel = 11;
        var miles = radius.miles > 0 ? radius.miles : 50;
        var numRad = local ? local : miles;
        var getMeter = numRad * helper/* METER */.Vw;
        var getRadius = getMeter + getMeter / 2;
        var scale = getRadius / 500;
        var x = 15;
        if (mode === "desktop") {
            x = 16.5;
        }
        zoomLevel = x - Math.log(scale) / Math.log(2);
        if (radius.miles > 0 && radius.miles === radius.max) {
            zoomLevel = 4;
        }
        if (event === "radius_changed") {
            setZoom((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, zoom), {
                default: zoomLevel
            }));
        } else {
            var listener = window.google.maps.event.addListener(map, event, function() {
                setZoom((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, zoom), {
                    default: zoomLevel
                }));
                window.google.maps.event.clearListeners(map, "idle");
            });
        }
    };
    // GET CURRENT LOCATION
    var currentLocation = function() {
        navigator.geolocation.getCurrentPosition(function(position) {
            var pos = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            };
            getAddress("current", pos.lat, pos.lng);
            setCenter(pos);
            setDefaultCenter(pos);
            setParamsQuery((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, paramsQuery), {
                lat: pos.lat.toString(),
                lng: pos.lng.toString()
            }));
            if (map) {
                (0,helper/* sleep */._v)(1000).then(function() {
                    onBoundCircle(map, "radius_changed");
                });
            }
        }, function() {
            setCenter(helper/* MAP_DEFAULT */.he);
            setDefaultCenter(helper/* MAP_DEFAULT */.he);
            getAddress("current", helper/* MAP_DEFAULT.lat */.he.lat, helper/* MAP_DEFAULT.lng */.he.lng);
            setParamsQuery((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, paramsQuery), {
                lat: helper/* MAP_DEFAULT.lat.toString */.he.lat.toString(),
                lng: helper/* MAP_DEFAULT.lng.toString */.he.lng.toString()
            }));
            if (map) {
                (0,helper/* sleep */._v)(1000).then(function() {
                    onBoundCircle(map, "radius_changed");
                });
            }
        });
    };
    // GET CHANGE LOCATION
    var changeLocation = function(place_id, desc) {
        var geocode = new window.google.maps.Geocoder();
        geocode.geocode({
            placeId: place_id
        }).then(function(param) {
            var results = param.results;
            var pos = {
                lat: results[0].geometry.location.lat(),
                lng: results[0].geometry.location.lng()
            };
            setPlaceID(results[0]);
            setCity(results[0].formatted_address);
            getCity === null || getCity === void 0 ? void 0 : getCity(results[0].formatted_address);
            setCenter(pos);
            setDefaultCenter(pos);
            setParamsQuery((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, paramsQuery), {
                lat: pos.lat.toString(),
                lng: pos.lng.toString()
            }));
            if (map) {
                (0,helper/* sleep */._v)(1000).then(function() {
                    onBoundCircle(map, "radius_changed");
                });
            }
        });
    };
    var getAddress = function() {
        var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", lat = arguments.length > 1 ? arguments[1] : void 0, lng = arguments.length > 2 ? arguments[2] : void 0;
        var latlng = map.getCenter();
        if (type) {
            latlng = new google.maps.LatLng(lat, lng);
        }
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({
            location: latlng,
            region: "us"
        }, function(results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                if (results) {
                    var res = (0,helper/* getSpesificResultGeocode */.D5)(results, "street_address");
                    setPlaceID(res);
                    setCity(res.formatted_address);
                    getCity === null || getCity === void 0 ? void 0 : getCity(res.formatted_address);
                }
            }
        });
    };
    //   GET API
    var getAPI = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (delay) {
                            return [
                                2,
                                false
                            ];
                        }
                        setFacility([]);
                        setTotalFac(0);
                        setDelay(true);
                        setLoading(true);
                        onLoading === null || onLoading === void 0 ? void 0 : onLoading(true);
                        data = (0,src_object_spread/* default */.Z)({}, paramsQuery);
                        setParams((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, paramsQuery), {
                            times: luxon/* DateTime.now */.ou.now().toISO()
                        }));
                        return [
                            4,
                            axios/* client.post */.Lp.post("/m/pricing-plan", data).then(function(response) {
                                setItems({
                                    status: "OK",
                                    data: response.data,
                                    times: luxon/* DateTime.now */.ou.now().toISO()
                                });
                                setTypeFac(response.data.type);
                                setTimeout(function() {
                                    if (response.data.found) {
                                        setFacility(response.data.found.facilities);
                                        var num = 0;
                                        response.data.found.facilities.forEach(function(v) {
                                            return num = num + (response.data.type !== "area" ? v.total || 0 : 1);
                                        });
                                        setTotalFac(num);
                                        setTotal === null || setTotal === void 0 ? void 0 : setTotal(num);
                                    }
                                }, 100);
                                var localRadius = localStorage.getItem("radius") || "";
                                if (!localRadius) {
                                    localStorage.setItem("radius", JSON.stringify(response.data.radius));
                                    var date = luxon/* DateTime.now */.ou.now().plus({
                                        days: 1
                                    }).toISO();
                                    localStorage.setItem("time-radius", date);
                                }
                                if (radius.miles <= 0) {
                                    var localRadius1 = localStorage.getItem("radius") || "";
                                    if (localRadius1) {
                                        var rad = JSON.parse(localRadius1);
                                        setRadius({
                                            miles: rad.default,
                                            meter: rad.default * helper/* METER */.Vw,
                                            min: rad.waypoints[0],
                                            max: rad.waypoints[rad.waypoints.length - 1],
                                            mobile: rad.default,
                                            waypoints: rad.waypoints
                                        });
                                    } else {
                                        setRadius({
                                            miles: response.data.radius.default > 0 ? response.data.radius.default : 50,
                                            meter: (response.data.radius.default > 0 ? response.data.radius.default : 50) * helper/* METER */.Vw,
                                            min: response.data.radius.waypoints[0],
                                            max: response.data.radius.waypoints[response.data.radius.waypoints.length - 1],
                                            mobile: response.data.radius.default > 0 ? response.data.radius.default : 50,
                                            waypoints: response.data.radius.waypoints
                                        });
                                    }
                                    setParams((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, params), {
                                        radius: response.data.radius.default > 0 ? response.data.radius.default : 50
                                    }));
                                }
                            }).catch(function(err) {
                                var ref, ref1;
                                setItems({
                                    data: CalculateDefaultValue,
                                    status: "NOTFOUND",
                                    times: luxon/* DateTime.now */.ou.now().toISO()
                                });
                                setTotal === null || setTotal === void 0 ? void 0 : setTotal(0);
                                if (radius.miles <= 0) {
                                    var localRadius = localStorage.getItem("radius") || "";
                                    if (localRadius) {
                                        var rad = JSON.parse(localRadius);
                                        setRadius({
                                            miles: rad.default,
                                            meter: rad.default * helper/* METER */.Vw,
                                            min: rad.waypoints[0],
                                            max: rad.waypoints[rad.waypoints.length - 1],
                                            mobile: rad.default,
                                            waypoints: rad.waypoints
                                        });
                                    } else {
                                        var num = 15;
                                        var way = [
                                            15,
                                            500
                                        ];
                                        setRadius({
                                            miles: num,
                                            meter: num * helper/* METER */.Vw,
                                            min: way[0],
                                            max: way[way.length - 1],
                                            mobile: num,
                                            waypoints: way
                                        });
                                    }
                                }
                                if ((err === null || err === void 0 ? void 0 : err.response) && (err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) === "Sorry failed to get address detail") {
                                    setCity("Unknown location");
                                }
                            }).finally(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                var ref;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            setLoadingCluster(false);
                                            (ref = clustererRef.current) === null || ref === void 0 ? void 0 : ref.repaint();
                                            return [
                                                4,
                                                (0,helper/* sleep */._v)(1000).then(function() {
                                                    setLoading(false);
                                                    onLoading === null || onLoading === void 0 ? void 0 : onLoading(false);
                                                    setDelay(false);
                                                })
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function getAPI() {
            return _ref.apply(this, arguments);
        };
    }();
    var setFilterMapBound = function(map) {
        var isParams = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, addParams = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
        if (!map) {
            return null;
        }
        var boundZoom = map.getZoom();
        var mapCenter = map.getCenter();
        var pos = {
            lat: mapCenter.lat(),
            lng: mapCenter.lng()
        };
        // zoom level below 6 must display whole country
        if (addParams) {
            addParams = (0,src_object_spread/* default */.Z)({}, addParams);
        }
        var zoomMap = {
            map_zoom: addParams && addParams.map_zoom ? addParams.map_zoom : Math.ceil(boundZoom)
        };
        if (isParams) {
            setParamsQuery((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, paramsQuery, addParams ? (0,src_object_spread/* default */.Z)({}, addParams, zoomMap) : zoomMap), {
                // lat: pos.lat.toString(),
                // lng: pos.lng.toString(),
                times: luxon/* DateTime.now */.ou.now().toISO(),
                radius: wayvalue
            }));
        }
    };
    // change radius
    (0,react.useEffect)(function() {
        if (wayvalue) {
            if (wayvalue === radius.max) {
                var featureLayer = map.getFeatureLayer("COUNTRY");
                featureLayer.style = function(options) {
                    if (options.feature.placeId === helper/* MAP_USA */.$J) {
                        return helper/* boundariesUSA */.JO;
                    }
                };
                setDefaultCenter(helper/* USA_CENTER */.lC);
                setCenter(helper/* USA_CENTER */.lC);
                setLastParams({
                    lat: paramsQuery.lat,
                    lng: paramsQuery.lng
                });
                setParamsQuery((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, paramsQuery), {
                    radius: wayvalue,
                    times: ""
                }));
                setZoom((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, zoom), {
                    default: mode === "desktop" ? 4 : 2
                }));
                setVisible(false);
                setDisabled(true);
                setType("full");
            } else {
                var featureLayer1 = map.getFeatureLayer("COUNTRY");
                featureLayer1.style = null;
                setVisible(true);
                setDisabled(false);
                setType("partial");
                if (!lastParams.lat && !lastParams.lng) {
                    setParamsQuery((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, paramsQuery), {
                        radius: wayvalue,
                        times: ""
                    }));
                    onBoundCircle(map, "radius_changed");
                }
            }
        }
    }, [
        wayvalue
    ]);
    (0,react.useEffect)(function() {
        if (items.times && params.times) {
            onChange === null || onChange === void 0 ? void 0 : onChange(items, params);
        }
    }, [
        items
    ]);
    (0,react.useEffect)(function() {
        if (type === "partial" && lastParams.lat && lastParams.lng) {
            var lat = lastParams.lat;
            var lng = lastParams.lng;
            setDefaultCenter({
                lat: Number(lat),
                lng: Number(lng)
            });
            setCenter({
                lat: Number(lat),
                lng: Number(lng)
            });
            if (map) {
                (0,helper/* sleep */._v)(1000).then(function() {
                    onBoundCircle(map, "radius_changed");
                    setLastParams({
                        lat: "",
                        lng: ""
                    });
                });
            }
        }
    }, [
        type
    ]);
    (0,react.useEffect)(function() {
        var date = luxon/* DateTime.now */.ou.now();
        var localDate = localStorage.getItem("time-radius") || "";
        if (localDate) {
            var setDate = luxon/* DateTime.fromISO */.ou.fromISO(localDate);
            if (date.toString() > setDate.toString()) {
                localStorage.removeItem("radius");
            }
        }
    }, []);
    (0,react.useEffect)(function() {
        if (placeID) {
            var data = {
                state: (0,helper/* getDynamicResult */.w6)(placeID, "administrative_area_level_1"),
                city: (0,helper/* getDynamicResult */.w6)(placeID, "locality"),
                zipcode: (0,helper/* getDynamicResult */.w6)(placeID, "postal_code"),
                address: placeID.formatted_address,
                radius: paramsQuery.radius || 50,
                price_monthly: items.data.pricing.monthly,
                price_yearly: items.data.pricing.yearly
            };
            // @ts-ignore
            analytics.ready(function() {
                // @ts-ignore
                analytics.reset();
                // @ts-ignore
                analytics.track("pricing_plan", data);
            });
        }
    }, [
        placeID,
        items
    ]);
    (0,react.useEffect)(function() {
        if (paramsQuery.times) {
            getAPI();
        }
    }, [
        paramsQuery
    ]);
    (0,react.useEffect)(function() {
        if (map) {
            getAddress();
            (0,helper/* sleep */._v)(1000).then(function() {
                onBoundCircle(map, "radius_changed");
            });
        }
    }, [
        map
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isLoaded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_esm/* GoogleMap */.b6, {
                id: "map_sual",
                mapContainerClassName: "w-full h-full rounded-[0.875rem] flex flex-col p-4.5",
                center: defaultCenter,
                zoom: zoom.default,
                options: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, helper/* OPTIONS */.JY), {
                    draggable: false
                }),
                onLoad: onLoad,
                onUnmount: onUnmount,
                onDragEnd: function() {
                    return setFilterMapBound(map);
                },
                onZoomChanged: function() {
                    return setFilterMapBound(map);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_esm/* Circle */.Cd, {
                            center: center,
                            radius: radius.meter,
                            options: {
                                strokeColor: "#3366FF",
                                strokeOpacity: 1,
                                strokeWeight: 1,
                                fillColor: "#3366FF",
                                fillOpacity: 0.2,
                                map: map,
                                zIndex: 1
                            },
                            visible: visible
                        }),
                        radius.miles < radius.max && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_esm/* Marker */.Jx, {
                            icon: "/marker.svg",
                            position: center
                        }),
                        !loadingCluster && typeFac && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_esm/* MarkerClusterer */.XL, {
                            styles: typeFac === "area" ? [
                                {
                                    textColor: "white",
                                    url: "/images/map/cluster/m1.svg",
                                    height: 60,
                                    width: 60
                                }, 
                            ] : typeFac === "city" ? [
                                {
                                    textColor: "white",
                                    url: "/images/map/cluster/mc1.svg",
                                    height: 60,
                                    width: 60
                                }, 
                            ] : typeFac === "state" ? [
                                {
                                    textColor: "white",
                                    url: "/images/map/cluster/ms1.svg",
                                    height: 60,
                                    width: 60
                                }, 
                            ] : [],
                            onLoad: function(clusterer) {
                                return clustererRef.current = clusterer;
                            },
                            onClick: function(clusterer) {
                                var ref, ref1;
                                var pos = {
                                    lat: (ref = clusterer.getCenter()) === null || ref === void 0 ? void 0 : ref.lat(),
                                    lng: (ref1 = clusterer.getCenter()) === null || ref1 === void 0 ? void 0 : ref1.lng()
                                };
                                // @ts-ignore
                                setDefaultCenter(pos);
                                // @ts-ignore
                                setCenter(pos);
                            },
                            zoomOnClick: true,
                            children: function(clusterer) {
                                clusterer.redraw();
                                clusterer.repaint();
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: facility.map(function(e, key) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_esm/* Marker */.Jx, {
                                            icon: typeFac === "area" ? "/images/map/icon/pin-marker.svg" : typeFac === "city" ? "/images/map/icon/pin-marker-cities.svg" : "/images/map/icon/pin-marker-states.svg",
                                            position: {
                                                lat: e.lat,
                                                lng: e.lng
                                            },
                                            clusterer: clusterer,
                                            zIndex: 50,
                                            onClick: function() {
                                                if (typeFac !== "area") {
                                                    var pos = {
                                                        lat: e.lat,
                                                        lng: e.lng
                                                    };
                                                    setDefaultCenter(pos);
                                                    setCenter(pos);
                                                    (0,helper/* sleep */._v)(1000).then(function() {
                                                        setZoom((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, zoom), {
                                                            default: 11
                                                        }));
                                                    });
                                                }
                                            }
                                        }, key);
                                    })
                                });
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row justify-between w-full ",
                                children: [
                                    searchShow && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "fixed inset-0 z-10 transition-opacity bg-transparent opacity-50 ".concat(searchShow === "close" && "hidden"),
                                        onClick: function() {
                                            setSearchShow("close");
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-full absolute left-0 z-10",
                                        children: map && /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoCompleteMap/* default */.Z, {
                                            label: "Search location...",
                                            changeLocation: changeLocation,
                                            currentLocation: currentLocation,
                                            searchShow: function(e) {
                                                return setSearchShow(e);
                                            },
                                            show: searchShow,
                                            searchResult: city,
                                            disabled: disabled
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative mt-auto",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "absolute right-2 bottom-20 flex flex-col space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-auto shadow-lv3 flex flex-col bg-transparent rounded-xl",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "p-3 bg-white rounded-xl hover:bg-neutral-200 cursor-pointer transition ease-in-out duration-200",
                                                onClick: currentLocation,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* GpsIcon */.YZ, {})
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "w-auto shadow-lv3 flex flex-col bg-transparent rounded-xl",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "p-3 pb-1.5 bg-white rounded-t-xl hover:bg-neutral-200 cursor-pointer transition ease-in-out duration-200",
                                                    onClick: function() {
                                                        var res = ((map === null || map === void 0 ? void 0 : map.getZoom()) || 0) + 1;
                                                        setZoom((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, zoom), {
                                                            default: res
                                                        }));
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* PlusIcon */.pO, {})
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "p-3 pt-1.5 bg-white rounded-b-xl hover:bg-neutral-200 cursor-pointer transition ease-in-out duration-200",
                                                    onClick: function() {
                                                        var res = ((map === null || map === void 0 ? void 0 : map.getZoom()) || 0) - 1;
                                                        setZoom((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, zoom), {
                                                            default: res
                                                        }));
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* MinusIcon */.V_, {})
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(map_RadiusWaypoints, {
                                    className: "hidden sm:hidden md:block lg:block",
                                    radius: radius,
                                    onAfterChange: function(e) {
                                        setWayvalue(e);
                                        setRadius((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, radius), {
                                            meter: e * helper/* METER */.Vw,
                                            miles: e
                                        }));
                                    },
                                    onChange: function(e) {
                                        setRadius((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, radius), {
                                            meter: e * helper/* METER */.Vw,
                                            miles: e
                                        }));
                                    },
                                    marks: (0,helper/* createRadius */.TW)(radius.waypoints)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "group relative lg:hidden md:hidden",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                        className: "bg-white flex flex-row p-2 px-5 w-full shadow-lv3 rounded-xl relative",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "w-1/3 text-neutral-600",
                                                children: "Pick Radius"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                                className: "text-right px-4 w-2/3",
                                                onChange: function(e) {
                                                    setWayvalue(parseInt(e.target.value));
                                                    setRadius((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, radius), {
                                                        meter: parseInt(e.target.value) * helper/* METER */.Vw,
                                                        miles: parseInt(e.target.value)
                                                    }));
                                                },
                                                children: radius.waypoints.map(function(item, key) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                                        value: item,
                                                        children: [
                                                            item,
                                                            " Miles"
                                                        ]
                                                    }, key);
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* LoadingMap */.Qu, {}),
            loadError && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "p-6 text-neutral-900",
                children: "Map cannot be loaded right now, sorry."
            })
        ]
    });
};
/* harmony default export */ var map_Map = (Map);

// EXTERNAL MODULE: ./app/helpers/ContentList.tsx
var ContentList = __webpack_require__(7923);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(7333);
;// CONCATENATED MODULE: ./app/helpers/formatMoney.tsx
// @ts-nocheck




var formatMoney = function(value) {
    var res = /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
        value: value,
        displayType: "text",
        thousandSeparator: true,
        prefix: "$"
    });
    return res;
};
var formatMoneyExtra = function(value) {
    var res = /*#__PURE__*/ _jsx(NumericFormat, {
        value: value,
        className: "foo",
        displayType: "text",
        thousandSeparator: true,
        prefix: "$",
        renderText: function(value, props) {
            return /*#__PURE__*/ _jsxs("p", _object_spread_props(_object_spread({}, props), {
                children: [
                    "Save ",
                    value,
                    "/month by purchasing yearly subcription"
                ]
            }));
        }
    });
    return res;
};
var formatCurrency = function(input) {
    return input === null || input === void 0 ? void 0 : input.toString().replace("-", "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

// EXTERNAL MODULE: ./app/layouts/DefaultLayout.tsx + 2 modules
var DefaultLayout = __webpack_require__(7213);
;// CONCATENATED MODULE: ./pages/pricing-plan/index.tsx



















var Index = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(""), mode = ref[0], setMode = ref[1];
    var ref1 = (0,react.useState)("monthly"), plan = ref1[0], setPlan = ref1[1];
    var ref2 = (0,react.useState)({
        status: "",
        data: {
            city: "",
            zipcode: "",
            found: {
                facilities: [],
                upcoming_auction: 0,
                avg_auction_monthly: 0
            },
            pricing: {
                monthly: 0,
                yearly: 0,
                yearly_save_value: 0,
                yearly_save_percentage: 0
            }
        }
    }), items = ref2[0], setItems = ref2[1];
    var ref3 = (0,react.useState)({
        lat: "",
        lng: "",
        radius: "",
        plan: "",
        map_zoom: 11
    }), params = ref3[0], setParams = ref3[1];
    var ref4 = (0,react.useState)(true), loading = ref4[0], setLoading = ref4[1];
    var ref5 = (0,react.useState)(0), totalFac = ref5[0], setTotalFac = ref5[1];
    var ref6 = (0,react.useState)(""), city = ref6[0], setCity = ref6[1];
    (0,react.useEffect)(function() {
        if (window.innerWidth < 768) {
            setMode("mobile");
        } else {
            setMode("desktop");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default */.Z, {
                title: "Pricing | Storage Unit Auction List",
                description: "StorageUnitAuctionList.com charges different fees for its services, which you can explore by selecting a radius and then a subscription plan. All plans are offered on a monthly or yearly basis, and we accept all major credit cards."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultLayout/* default */.Z, {
                topFooter: "!mt-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container mx-auto ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                            className: "mt-12 md:mt-[5.75rem] flex flex-col items-center justify-center text-center px-4.5 md:px-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-warning-500 text-regular-tight md:text-large-none md:font-bold font-medium uppercase",
                                    children: "Pricing"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-4 md:mt-3.5 text-neutral-900 font-bold md:text-title1 md:leading-[3.625rem] text-title3 leading-[2.125rem]",
                                    children: "Select A Location & Subscription Type"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-4 md:mt-3.5 text-neutral-700 text-large-normal leading-7 md:w-[30rem] hidden md:block",
                                    children: "Join over 300,000 storage unit buyers who rely on us to hunt for storage unit auctions happening near them"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-4.5 text-neutral-700 text-small-normal leading-6 md:w-[20.625rem] md:hidden px-2",
                                    children: "Join over 300,000 storage unit buyers who rely on us to hunt for storage unit auctions happening near them"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                            className: "mt-6 lg:mt-[2.125rem] mx-4.5 lg:mx-8 xl:mx-16 flex flex-col-reverse lg:flex-row lg:space-x-5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-7 lg:mt-0 lg:w-7/12 h-[37.5rem] lg:h-[48.375rem]",
                                    children: mode && /*#__PURE__*/ (0,jsx_runtime.jsx)(map_Map, {
                                        mode: mode,
                                        onChange: function(e, p) {
                                            setItems(e);
                                            setParams((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, p), {
                                                plan: plan
                                            }));
                                        },
                                        setTotal: function(e) {
                                            setTotalFac(e);
                                        },
                                        onLoading: function(e) {
                                            setLoading(e);
                                        },
                                        getCity: function(e) {
                                            setCity(e);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col lg:w-5/12",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-neutral-900 font-bold text-title2 leading-[3rem] hidden lg:block",
                                            children: "Storage Unit Auctions Found"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mt-2 text-neutral-600 text-large-tight hidden lg:block",
                                            children: [
                                                "Found ",
                                                totalFac,
                                                " facilities and",
                                                " ",
                                                items.data.found.upcoming_auction,
                                                " auctions happening this week"
                                            ]
                                        }),
                                        items.status === "NOTFOUND" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mt-6 lg:py-4.5 lg:px-6 flex flex-col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "bg-danger-50 rounded-full p-2.5 text-danger-500 w-fit",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* LocationCrossBoldIcon */.bQ, {
                                                        size: "48"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mt-6 flex flex-col",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "text-primary-900 font-bold text-title3",
                                                            children: "Subscription not available \uD83D\uDE14"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "mt-3 text-neutral-900 text-xl leading-[1.875rem]",
                                                            children: "Sorry, the selected location and radius have either no storage facilities or low number of upcoming auctions"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mt-7 w-full rounded-full p-2 grid grid-cols-2 gap-x-5 bg-neutral-200",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat(plan === "monthly" ? "bg-white font-bold text-primary-500" : "bg-transparent font-medium text-neutral-500", " w-full p-3 text-center flex items-center justify-center cursor-pointer text-regular-none rounded-full hover:bg-white hover:font-bold hover:text-primary-500 hover-anime"),
                                                            onClick: function() {
                                                                setPlan("monthly");
                                                                setParams((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, params), {
                                                                    plan: "monthly"
                                                                }));
                                                            },
                                                            children: "Monthly"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat(plan === "yearly" ? "bg-white font-bold text-primary-500" : "bg-transparent font-medium text-neutral-500", " w-full p-3 text-center flex items-center justify-center cursor-pointer text-regular-none rounded-full hover:bg-white hover:font-bold hover:text-primary-500 hover-anime"),
                                                            onClick: function() {
                                                                setPlan("yearly");
                                                                setParams((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, params), {
                                                                    plan: "yearly"
                                                                }));
                                                            },
                                                            children: "Yearly"
                                                        })
                                                    ]
                                                }),
                                                !loading && items.status ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mt-8 flex flex-col px-6 py-4.5 rounded-3xl border border-neutral-200",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "font-bold text-primary-900 text-title2",
                                                            children: plan === "yearly" ? "Yearly" : "Monthly"
                                                        }),
                                                        plan === "yearly" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "mt-3 text-neutral-900 text-xl leading-[1.875rem]",
                                                            children: [
                                                                "Save",
                                                                " ",
                                                                formatMoney(items.data.pricing.yearly_save_value),
                                                                "/year with a yearly plan"
                                                            ]
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "mt-3 text-neutral-900 text-xl leading-[1.875rem]",
                                                            children: "Sign up for a month to month plan"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "mt-[1.875rem] font-bold text-info-500 text-title2",
                                                            children: [
                                                                plan === "yearly" ? formatMoney(items.data.pricing.yearly) : formatMoney(items.data.pricing.monthly),
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: "font-normal text-neutral-900 text-regular-normal",
                                                                    children: [
                                                                        "/",
                                                                        plan === "yearly" ? "Year" : "Month"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "mt-8 w-full",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: items.status === "NOTFOUND" ? "#" : "".concat("https://app.storageunitauctionlist.com", "/b/sign-up?lat=").concat(params.lat, "&lng=").concat(params.lng, "&radius=").concat(params.radius, "&plan=").concat(params.plan, "&address=").concat(city, "&map_zoom=").concat(params.map_zoom),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    target: "_blank",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                        size: "lg",
                                                                        className: "!rounded-full w-full !font-medium",
                                                                        onClick: function() {},
                                                                        disabled: items.status === "NOTFOUND",
                                                                        children: "Subscribe Now"
                                                                    })
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "mt-6",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "font-bold text-primary-900 text-title3",
                                                                    children: "This is what you get"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "mt-3 grid grid-cols-1 gap-y-3",
                                                                    children: ContentList/* what_you_got.map */.vH.map(function(e, key) {
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                                                            className: "flex flex-row items-center space-x-3",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "text-success-600",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* TickBulkCircleIcon */.PV, {})
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "text-xl leading-[1.875rem] text-neutral-900",
                                                                                    children: e
                                                                                })
                                                                            ]
                                                                        }, key);
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* LoadingPricingPlan */.tf, {})
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                            className: "mt-6 lg:hidden flex flex-col px-4.5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-neutral-900 font-bold text-large-normal",
                                    children: "Storage Unit Auctions Found"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-2 text-neutral-700 text-small-normal pr-5",
                                    children: [
                                        "Found ",
                                        items.data.found.facilities.length,
                                        " auctions and ",
                                        totalFac,
                                        " ",
                                        "of them happening this week"
                                    ]
                                })
                            ]
                        }),
                        items.status !== "NOTFOUND" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                            className: "mt-4.5 lg:hidden relative group",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "absolute right-4.5 opacity-0 group-hover:opacity-100 hover-anime",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bg-white rounded-full p-3 shadow-lv3",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* ArrowRight2Icon */.RE, {})
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "px-4.5 overflow-x-auto sidebar flex flex-row items-center space-x-5",
                                    children: items.data.found.facilities.map(function(e, key) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* CardAuction */.fe, {}, key);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                            className: "".concat(mode === "mobile" ? "gradient-main" : ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-12 md:mt-[7.75rem] mx-4.5 md:mx-8 xl:mx-16 md:pt-0 pt-11",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "grid grid-cols-1 md:grid-cols-2 gap-y-[1.375rem] md:gap-x-5 md:gap-y-0 w-full",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* AnimationOnScroll */.n, {
                                                animateIn: "animate__fadeIn",
                                                animateOnce: true,
                                                className: "text-neutral-900 font-bold text-title3 leading-[2.125rem] md:text-title1 md:leading-[3.625rem] text-center md:text-left",
                                                children: [
                                                    "The Leading",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-gradient-7",
                                                        children: "Storage Unit Auction"
                                                    }),
                                                    " ",
                                                    "Search Engine"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* AnimationOnScroll */.n, {
                                                animateIn: "animate__fadeIn",
                                                animateOnce: true,
                                                className: "text-neutral-700 md:text-neutral-900 text-small-normal leading-6 md:text-title3 md:leading-[2.125rem] text-center md:text-left",
                                                children: "Storage unit buyers from all over the country use Storage Unit Auction list to find the most up to date auction listings."
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-7 md:mt-[7.75rem] mx-4.5 md:mx-8 xl:mx-16 relative md:pt-[3.125rem] md:pb-11 flex flex-col items-center justify-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "absolute z-0 top-0 gradient-main rounded-[3rem] w-full md:w-[54.25rem] h-full md:h-[42.125rem] md:block hidden"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex flex-col md:flex-wrap md:flex-row justify-center items-center md:gap-x-5 gap-y-3.5 relative w-full",
                                            children: (0,_to_consumable_array/* default */.Z)(ContentList/* pricing_1 */.uH).concat((0,_to_consumable_array/* default */.Z)(ContentList/* pricing_2 */.T1)).map(function(e, key) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* AnimationOnScroll */.n, {
                                                    className: "w-full bg-white shadow-lv4 rounded-3xl p-6 flex flex-col items-center justify-center md:w-5/12 lg:w-[24rem] md:h-[19rem]",
                                                    animateIn: "animate__zoomIn",
                                                    animateOnce: true,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                            src: e.icon,
                                                            alt: e.title,
                                                            className: "w-[5.875rem] h-[5.875rem]"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "font-bold text-neutral-900 text-xl leading-[1.875rem] md:!text-title3 mt-3 md:mt-6 text-center",
                                                            children: e.title
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "text-small-normal md:text-large-normal md:text-neutral-900 mt-3 text-center",
                                                            children: e.subtitle
                                                        })
                                                    ]
                                                }, key);
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var pricing_plan = (Index);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [255,939,780,506,697,659,286,774,888,179], function() { return __webpack_exec__(3976); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);